import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ListGroup from "react-bootstrap/ListGroup";
import { Card, Col, Row } from "react-bootstrap";
import CardHeader from "../../components/common/CardHeader";
import LinkButton from "../../components/common/LinkButton";
import { ItemShow } from "../../components/form";
import { privateApi } from "../../api";

const FaqShow = () => {
      const { faqId } = useParams();
      const [faq, setFaq] = useState([]);

      const loadData = async () => {
            await privateApi
                  .get(`/dashboard/faqs/${faqId}`)
                  .then((response) => {
                        if (response.data.result === "success") {
                              setFaq(response.data.faq);
                        }
                  })
                  .catch((error) => {
                        console.log(error.message);
                  });
      };

      useEffect(() => {
            loadData();
      }, []);

      return (
            <>
                  <Row>
                        <Col lg={12}>
                              <Card>
                                    <CardHeader title="Faq Details">
                                          <LinkButton
                                                link="/dashboard/faqs"
                                                title="Back"
                                          />
                                    </CardHeader>
                                    <Card.Body>
                                          <Row>
                                                <Col lg={8}>
                                                      <ListGroup>
                                                            <ItemShow
                                                                  title="Question"
                                                                  value={
                                                                        faq.question
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Answer"
                                                                  value={
                                                                        faq.answer
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Type"
                                                                  value={
                                                                        faq.category
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Status"
                                                                  value={
                                                                        faq.status ? (
                                                                              <>
                                                                                    <span className="text-success">
                                                                                          Active
                                                                                    </span>
                                                                              </>
                                                                        ) : (
                                                                              <>
                                                                                    <span className="text-warning">
                                                                                          Disable
                                                                                    </span>
                                                                              </>
                                                                        )
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="Date"
                                                                  value={
                                                                        faq.date
                                                                  }
                                                            />
                                                            <ItemShow
                                                                  title="By "
                                                                  value={
                                                                        faq.user_name
                                                                  }
                                                            />
                                                      </ListGroup>
                                                </Col>
                                          </Row>
                                    </Card.Body>
                              </Card>
                        </Col>
                  </Row>
            </>
      );
};

export default FaqShow;
